import { TableRow, Text } from 'platform-components';
import React from 'react';

import StudentRow from 'common.components/students/__student-row/students__student-row';
import { Student } from 'common.components/typings';

interface Props {
    canEditClass: boolean;
    code: string;
    isArchiveClass: boolean;
    teamId: number;
    students: Array<Student> | null;
    shouldShowPassportAccounts: boolean;
}

import './students__table-content.scss';

export const StudentTableContent = (props: Props) => {
    const { canEditClass, code, isArchiveClass, shouldShowPassportAccounts, students, teamId } = props;

    return (
        <>
            {students?.length ? (
                students.map((student) => (
                    <StudentRow
                        classId={teamId}
                        code={code}
                        isArchiveClass={isArchiveClass}
                        key={student.id}
                        showPassportAccount={shouldShowPassportAccounts}
                        student={student}
                        students={students}
                        studentsCount={students ? students.length : 0}
                    />
                ))
            ) : (
                <TableRow contentMix="students__table-empty-content">
                    <div className="students__no-students-header">
                        <Text id="class.table.emptyState.header" size={Text.SIZE.XL} weight={Text.WEIGHT.M} />
                    </div>
                    <div className="students__no-students-description">
                        <Text
                            id={
                                canEditClass
                                    ? 'class.table.emptyState.description'
                                    : 'class.notEditable.table.emptyState.description'
                            }
                            size={Text.SIZE.XL}
                        />
                    </div>
                </TableRow>
            )}
        </>
    );
};
